import React, { useState } from "react";

/* IMAGES */
import restaurantImg from "../../../assets/EMP_clients/CaseStudy/caseStudy1.webp";
import retailImg from "../../../assets/EMP_clients/CaseStudy/caseStudy2.webp";
import customerImg from "../../../assets/EMP_clients/CaseStudy/caseStudy3.webp";
import healthcareImg from "../../../assets/EMP_clients/CaseStudy/caseStudy4.webp";
import manufacturingImg from "../../../assets/EMP_clients/CaseStudy/caseStudy5.webp";
import aviationImg from "../../../assets/EMP_clients/CaseStudy/caseStudy6.webp";
const tabs = [
  {
    id: "restaurants",
    label: "Restaurants",

    title:
      "Dhanani Group has seen a 45% enrollment in DailyPay and a 43% decrease in turnover among enrolled employees.",

    industry: "Restaurants",

employees: (
  <>
    18,000
    <br />
    employees
  </>
),
    image: restaurantImg,
  },

  {
    id: "retail",
    label: "Retail",

    title:
      "Puma says DailyPay has increased efficiency, resulting in a 50% decrease in timecard reconciliations requiring review.",

    industry: "Retail",

employees: (
  <>
    38,000
    <br />
    employees
  </>
),
    image: retailImg,
  },

  {
    id: "customer",
    label: "Customer Service",

    title:
      "Alorica claims that DailyPay helps them compete in the labor market, with 70% of new hires enrolling in DailyPay.",

    industry: "Customer Service",

employees: (
  <>
    100000 ++
    <br />
    employees
  </>
),
    image: customerImg,
  },

  {
    id: "healthcare",
    label: "Healthcare",

    title:
      "The Springs Arkansas saves $2.6M per year in employee replacement costs.",

    industry: "Healthcare",

employees: (
  <>
    25,00
    <br />
    employees
  </>
),
    image: healthcareImg,
  },

  {
    id: "manufacturing",
    label: "Manufacturing",

    title:
      "Duracell employees asked their HR team for DailyPay. DailyPay users now have 59% higher tenure.",

    industry: "Manufacturing",

employees: (
  <>
    35,000
    <br />
    employees
  </>
),
    image: manufacturingImg,
  },

  {
    id: "aviation",
    label: "Aviation",

    title:
      "Worldwide Flight Services has freed up 10% of their finance and payroll teams’ time by moving to DailyPay.",

    industry: "Aviation",

employees: (
  <>
    18,000 ++
    <br />
    employees
  </>
),
    image: aviationImg,
  },
];

export default function CaseStudyTabs() {
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <section
      className="
        w-full

        bg-[white]

        py-10
        lg:py-1
      "
    >
      <div
        className="
          max-w-[1400px]
          lg:max-w-[1300px]

          mx-auto

          bg-[#260303]

          rounded-[40px]
          lg:rounded-[20px]

          px-6
          sm:px-10
          lg:px-16

          py-4
          lg:py-12
        "
      >
        {/* TOP TABS */}
       <div
  className="
    flex

    overflow-x-auto
    whitespace-nowrap

    scrollbar-hide

    gap-4
    lg:gap-4

    pb-2
  "
>
  {tabs.map((tab) => (
    <button
      key={tab.id}
      onClick={() => setActiveTab(tab)}
      className={`
        shrink-0

        px-6
        py-3

        lg:px-6
        lg:py-1

        rounded-full

        text-white

        text-[14px]
        lg:text-[15px]

        font-bold

        transition-all
        duration-300

        ${
          activeTab.id === tab.id
            ? "bg-[#7a4a4a]"
            : "bg-transparent"
        }
      `}
    >
      {tab.label}
    </button>
  ))}
</div>

        {/* CONTENT */}
        <div
          className="
            mt-10
            lg:mt-16

            grid
            grid-cols-1
            lg:grid-cols-2

            gap-10
            lg:gap-16

            items-center
          "
        >
          {/* LEFT */}
          <div>
            <h2
              className="
                text-white

                text-[34px]
                sm:text-[48px]
                lg:text-[34px]
                lg:font-sans
                lg:mt-[100px]

                leading-[1.3]
                lg:leading-[1.2]

                max-w-[650px]
                lg:max-w-[520px]
              "
            >
              {activeTab.title}
            </h2>

            <button
              className="
                mt-10
                lg:mt-6

                border
                border-white

                text-white

                px-6
                py-3
                lg:px-4
                lg:py-2

                text-[18px]
                font-bold

                hover:bg-white
                hover:text-[#4b0000]

                transition-all
                duration-300
              "
            >
              Read case study
            </button>

            {/* INFO */}
            <div
              className="
                mt-12

                border-t
                border-b
                border-[#7d5d5d]

                py-6

                max-w-[260px]
              "
            >
              <p
                className="
                  text-[#00d5ff]

                  uppercase

                  text-[14px]

                  font-bold

                  tracking-[2px]
                "
              >
                Industry
              </p>

              <h4
                className="
                  mt-4
                  lg:mt-2

                  text-white

                  text-[28px]
                  lg:text-[22px]

                  font-bold
                "
              >
                {activeTab.industry}
              </h4>

              <p
                className="
                  mt-5

                  text-white

                  text-[20px]
                  lg:text-[16px]
                "
              >
                {activeTab.employees}
              </p>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div
            className="
              overflow-hidden

              rounded-[20px]
              lg:w-[615px]
              lg:-ml-[50px]
            "
          >
            <img
              src={activeTab.image}
              alt={activeTab.label}

              className="
                w-full

                h-[350px]
                sm:h-[500px]
                lg:h-[550px]

                object-cover

                transition-all
                duration-500
              "
            />
          </div>
        </div>
      </div>
    </section>
  );
}